import { render, staticRenderFns } from "./articleSimplify.vue?vue&type=template&id=94c3bda4&scoped=true&"
import script from "./articleSimplify.vue?vue&type=script&lang=js&"
export * from "./articleSimplify.vue?vue&type=script&lang=js&"
import style0 from "./articleSimplify.vue?vue&type=style&index=0&lang=css&"
import style1 from "./articleSimplify.vue?vue&type=style&index=1&id=94c3bda4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c3bda4",
  null
  
)

export default component.exports